import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "album-container" }
const _hoisted_2 = {
  key: 0,
  class: "mt-5 flex flex-col space-y-3 md:flex-row md:space-x-4 md:space-y-0"
}
const _hoisted_3 = {
  key: 1,
  class: "mt-5 text-sm font-normal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.objectIds.length || _ctx.sharedAlbum)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "button-sm group",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.downloadAlbum && _ctx.downloadAlbum(...args)))
          }, [
            _cache[3] || (_cache[3] = _createElementVNode("svg", {
              width: "10px",
              height: "10px",
              class: "mr-1",
              focusable: "false",
              "aria-hidden": "true",
              viewBox: "0 0 54 54"
            }, [
              _createElementVNode("rect", {
                x: "4.5",
                y: "49.5",
                width: "45",
                height: "4.5"
              })
            ], -1)),
            _cache[4] || (_cache[4] = _createElementVNode("svg", {
              width: "10px",
              height: "10px",
              class: "group-hover:shake-down absolute",
              focusable: "false",
              "aria-hidden": "true",
              viewBox: "0 0 54 54"
            }, [
              _createElementVNode("path", {
                d: "M4.73,16.43L24.33,36L24.67,0L29.32,0L29.67,36L49.27,16.39L49.27,22.8L27,45L4.73,22.8L4.73,16.43Z",
                style: {"fill-rule":"nonzero"}
              })
            ], -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.t('download')), 1)
          ]),
          (!_ctx.sharedAlbum)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "button-sm group",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.shareMyAlbum && _ctx.shareMyAlbum(...args)))
              }, [
                _cache[5] || (_cache[5] = _createElementVNode("svg", {
                  width: "10px",
                  height: "10px",
                  class: "group-hover:shake-diagonal mr-1",
                  focusable: "false",
                  "aria-hidden": "true",
                  viewBox: "0 0 10 10"
                }, [
                  _createElementVNode("path", { d: "M9.084 7.328V1.684l-6.993 6.9-.669-.669 6.9-6.993H2.677l.916-.916 6.4.011.011 6.4z" })
                ], -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.t('share')), 1)
              ]))
            : _createCommentVNode("", true),
          (!_ctx.sharedAlbum)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "button-sm group",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.editAlbumName && _ctx.editAlbumName(...args)))
              }, [
                _cache[6] || (_cache[6] = _createElementVNode("svg", {
                  width: "10px",
                  height: "10px",
                  class: "mr-1",
                  focusable: "false",
                  "aria-hidden": "true",
                  viewBox: "0 0 54 54"
                }, [
                  _createElementVNode("path", {
                    class: "group-hover:shake-right",
                    d: "M49.5 0L18 31.5l-4.5 9 9-4.5L54 4.5 49.5 0z"
                  }),
                  _createElementVNode("path", { d: "M45 36v13.5H4.5V9H18V4.5H0V54h49.5V36H45z" }),
                  _createElementVNode("path", {
                    d: "M0 0h54v54H0z",
                    fill: "none"
                  })
                ], -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.t('edit_album_name')), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.t('no_objects_msg')), 1))
  ]))
}